/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	Fragment,
	useEffect,
	useRef,
} from '@wordpress/element'
import $ from 'jquery'
import { i18n, pluginAssetsURL } from 'cartzillagb'
import {
	PanelBody, ToggleControl, RangeControl, BaseControl, SelectControl 
} from '@wordpress/components'
import {
	RichText 
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import {
	BackgroundSettings, ColorSettings, ButtonControlsHelper, ButtonEditHelper, URLInputControl
} from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.hero-carousel-2.edit.inspector.style.before', 'czgb/hero-carousel-2', ( output, props ) => {
	const { 
		attributes, 
		setAttributes, 
		clientId,
	} = props

	const {
		limit,
		bannerlimit,
		bgcolor,
		custombgcolor,
		enableButton,
		blockId,
		autoplay
	} = props.attributes

	const slideLimitUpdate = limit => {
		if ( $( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		} else if ( $( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		}

		setAttributes( { limit } )
	}

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<RangeControl
					label={ __( 'No Of Slides', i18n ) }
					value={ limit }
					onChange={ limit => { slideLimitUpdate( limit ) } }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.limit', 5 ) }
				/>
				<RangeControl
					label={ __( 'No Of Side Banner', i18n ) }
					value={ bannerlimit }
					onChange={ bannerlimit => setAttributes( { bannerlimit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.bannerlimit', 3 ) }
				/>
				<BackgroundSettings
					background={ bgcolor !== undefined ? bgcolor : 'bg-secondary' }
					backgroundColor={ custombgcolor }
					onChangeBackground={ bgcolor => setAttributes( { bgcolor } ) }
					onChangeBackgroundColor={ custombgcolor => setAttributes( { custombgcolor: custombgcolor.hex } ) }
					onRemoveBackground={ () => { setAttributes( { bgcolor: '', custombgcolor: '' } ) } }
				/>
				<ToggleControl
					label={ __( 'Enable Autoplay?', i18n ) }
					checked={ autoplay }
					onChange={ autoplay => setAttributes( { autoplay } ) }
				/>
			</PanelBody>
			<Fragment>
				{ range( 1, limit + 1 ).map( i => {
					const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
					const enableTitle = attributes[ `enableTitle${ i }` ]
					const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

					let defaultBackgroundImage = ''

					if ( i % 5 === 1 ) {
					   defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img4.jpg`
					} 
					if ( i % 5 === 2 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img5.jpg`
					} 
					if ( i % 5 === 3 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img6.jpg`
					} 
					if ( i % 5 === 4 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img4-1.jpg`
					} 
					if ( i % 5 === 0 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img5-1.jpg`
					}

					return (
						<Fragment key={ i }>
							<PanelBody title={ __( `Slide Settings #${ i }`, i18n ) } initialOpen={ false }>
								<BackgroundSettings
									backgroundImageURL={ attributes[`mediaURL1${ i }`] !== undefined ? attributes[`mediaURL1${ i }`] : defaultBackgroundImage }
									onChangeBackgroundImage={ ( { url } ) => setAttributes( { [`mediaURL1${ i }`]: url } ) }
									onRemoveBackgroundImage={ () => { setAttributes( { [`mediaURL1${ i }`]: '' } ) } }
								/>
								<ToggleControl
									label={ __( 'Enable Pretitle', i18n ) }
									checked={ enablepreTitle }
									onChange={ enablepreTitle => setAttributes( { [ `enablepreTitle${ i }` ]: enablepreTitle } ) }
								/>

								<ToggleControl
									label={ __( 'Display Title', i18n ) }
									checked={ enableTitle }
									onChange={ enableTitle => setAttributes( { [ `enableTitle${ i }` ]: enableTitle } ) }
								/>

								<ToggleControl
									label={ __( 'Display Subtitle', i18n ) }
									checked={ enablesubTitle }
									onChange={ enablesubTitle => setAttributes( { [ `enablesubTitle${ i }` ]: enablesubTitle } ) }
								/>
								<ToggleControl
									label={ __( 'Display Button', i18n ) }
									checked={ enableButton }
									onChange={ enableButton => setAttributes( { enableButton } ) }
								/>
							</PanelBody>
							<PanelBody title={ __( 'Animation #', i18n ) + i } initialOpen={ false } key={ i }>
								<SelectControl
									label={ __( 'Pre-Title Animation' ) }
									values={ attributes[ `pretitleAnimation${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
										{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
										{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
										{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
									] }
									onChange={ value => setAttributes( {  [ `pretitleAnimation${ i }` ] : value } ) }
								/>

								<SelectControl
									label={ __( 'Pre-Title Delay' ) }
									values={ attributes[ `pretitleDelay${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
										{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
										{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
										{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
									] }
									onChange={ value => setAttributes( {  [ `pretitleDelay${ i }` ] : value } ) }
								/>

								<SelectControl
									label={ __( 'Title Animation' ) }
									values={ attributes[ `titleAnimation${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
										{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
										{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
										{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
									] }
									onChange={ value => setAttributes( {  [ `titleAnimation${ i }` ] : value } ) }
								/>

								<SelectControl
									label={ __( 'Title Delay' ) }
									values={ attributes[ `titleDelay${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
										{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
										{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
										{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
									] }
									onChange={ value => setAttributes( {  [ `titleDelay${ i }` ] : value } ) }
								/>

								<SelectControl
									label={ __( 'SubTitle Animation' ) }
									values={ attributes[ `subtitleAnimation${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
										{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
										{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
										{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
									] }
									onChange={ value => setAttributes( {  [ `subtitleAnimation${ i }` ] : value } ) }
								/>

								<SelectControl
									label={ __( 'SubTitle Delay' ) }
									values={ attributes[ `subtitleDelay${ i }` ] }
									options={ [
										{ label: __('None', 'cartzilla', i18n ), value: 'none' },
										{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
										{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
										{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
										{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
									] }
									onChange={ value => setAttributes( {  [ `subtitleDelay${ i }` ] : value } ) }
								/>
							</PanelBody>
							<PanelBody title={ __( `Button Settings #${ i }`, i18n ) } initialOpen={ false } >
								<ButtonControlsHelper
									attrNameTemplate={ `button${ i }%s"` }
									setAttributes={ setAttributes }
									blockAttributes={ props.attributes }
								/>
							</PanelBody>
						</Fragment>
					)
				} ) }

				{ range( 1, bannerlimit + 1 ).map( j => {
					const link = attributes[ `link${ j }` ] !== undefined ? attributes[ `link${ j }` ]  : '#'
					const bannertextcolor = attributes[ `bannertextcolor${ j }` ]
					const custombannertextcolor = attributes[ `custombannertextcolor${ j }` ]
					const bannerbgcolor = attributes[ `bannerbgcolor${ j }` ]
					const bannercustombgcolor = attributes[ `bannercustombgcolor${ j }` ]

					let defaultBackgroundImage = ''

					if ( j % 5 === 1 ) {
					   defaultBackgroundImage = `${ pluginAssetsURL }img/banner/img1.png`
					} 
					if ( j % 5 === 2 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/banner/img2.png`
					} 
					if ( j % 5 === 3 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/banner/img3.png`
					} 
					if ( j % 5 === 4 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/banner/img1.png`
					} 
					if ( j % 5 === 0 ) {
						defaultBackgroundImage = `${ pluginAssetsURL }img/banner/img2.png`
					}

					return (
						<PanelBody title={ __( `Banner Settings #${ j }`, i18n ) } initialOpen={ false } key={ j }>
							<BackgroundSettings
								backgroundImageURL={ attributes[`mediaURL2${ j }`] !== undefined ? attributes[`mediaURL2${ j }`] : defaultBackgroundImage }
								onChangeBackgroundImage={ ( { url } ) => setAttributes( { [`mediaURL2${ j }`]: url } ) }
								onRemoveBackgroundImage={ () => { setAttributes( { [`mediaURL2${ j }`]: '' } ) } }
							/>
							<URLInputControl
								value={ link }
								onChange={ link => setAttributes( { [ `link${ j }` ]: link } ) }
							/>
							<BackgroundSettings 
								background={ bannerbgcolor !== undefined ? bannerbgcolor : ' bg-primary' }
								backgroundColor={ bannercustombgcolor }
								onChangeBackground={ bannerbgcolor => setAttributes( { [ `bannerbgcolor${ j }` ]: ` ${ bannerbgcolor }`, [ `bannercustombgcolor${ j }` ]: '' } ) }
								onChangeBackgroundColor={ bannercustombgcolor => setAttributes( { [ `bannercustombgcolor${ j }` ]: bannercustombgcolor.hex, [ `bannerbgcolor${ j }` ]: '' } ) }
								onRemoveBackground={ () => { setAttributes( { [ `bannerbgcolor${ j }` ]: '', [ `bannercustombgcolor${ j }` ]: '' } ) } }
							/>
							<BaseControl label={ __( 'Banner Text color', i18n ) } id={ "color-3" } >
								<ColorSettings
									textColor={ bannertextcolor !== undefined ? bannertextcolor : 'text-primary' }
									textcustomColor={ custombannertextcolor }
									onChangetextColor={ bannertextcolor => setAttributes( { [ `bannertextcolor${ j }` ]: bannertextcolor } ) }
									onChangecustomColor={ custombannertextcolor => setAttributes( { [ `custombannertextcolor${ j }` ]: custombannertextcolor.hex } ) }
									onRemovetextColor={ () => { setAttributes( { [ `bannertextcolor${ j }` ]: '', [ `custombannertextcolor${ j }` ]: '' } ) } }
									>
								</ColorSettings>
							</BaseControl>
						</PanelBody>
					)
				} ) }
			</Fragment>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className,
		clientId,
	} = props 

	const {
		limit,
		bannerlimit,
		custombgcolor,
		bgcolor,
		enableButton,
		blockId,
		autoplay
	} = attributes

	const slickEl = useRef(clientId)
	const setBlockId = blockId => setAttributes({blockId})

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				slidesToShow: limit,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true )
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' )
		}
	}, [limit] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				autoplay: attributes.autoplay,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true )
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' )
		}
	}, [autoplay] )

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }

	const content = range( 1, limit + 1 ).map( i => {

		const Pretitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const MediaURL1 = attributes[ `mediaURL1${ i }` ]
		const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

		let defaultPretitle = ''
		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultImg = ''

		if ( i % 5 === 1 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4.jpg`
		}
		if ( i % 5 === 2 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5.jpg`
		}
		if ( i % 5 === 3 ) {
			defaultPretitle = 'Check our huge'
			defaultTitle = 'Smartphones'
			defaultSubtitle = '& Accessories collection'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img6.jpg`
		}
		if ( i % 5 === 4 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4-1.jpg`
		}
		if ( i % 5 === 0 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5-1.jpg`
		}

		const pretitleComp = enablepreTitle && (
			<RichText
				tagName="h2"
				value={ Pretitle || defaultPretitle }
				className={ `font-weight-light pb-1 from-bottom text-dark` }
				onChange={ Pretitle => setAttributes( { [ `pretitle${ i }` ]: Pretitle } ) }
				placeholder={ __( 'pretitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const titleComp = enableTitle && (
			<RichText
				tagName="h1"
				className={ `display-4 from-bottom delay-1 text-dark` } 
				value={ Title || defaultTitle }
				onChange={ Title => setAttributes( { [ `title${ i }` ]: Title } ) }
				placeholder={ __( 'Title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText
				tagName="h5"
				value={ subTitle || defaultSubtitle }
				className={ `font-weight-light pb-3 from-bottom delay-2 text-dark` }
				onChange={ subTitle => setAttributes( { [ `subtitle${ i }` ]: subTitle } ) }
				placeholder={ __( 'subtitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const buttonComp = enableButton && (
			<ButtonEditHelper
				attrNameTemplate={ `button${ i }%s"` }
				setAttributes={ setAttributes }
				blockAttributes={ props.attributes }
			/>
		)

		const output = (
			<div className="slide-wrapper" key={ i }>
				<div className="row align-items-center">
					<div className="col-md-6 order-md-2">
						<img className="d-block mx-auto" src={ MediaURL1 !== undefined ? MediaURL1 : defaultImg } alt="Vr Collection" />
					</div>
					<div className="col-lg-5 col-md-6 offset-lg-1 order-md-1 pt-4 pb-md-4 text-center text-md-left">
						{ pretitleComp }
						{ titleComp }
						{ subtitleComp }
						{ buttonComp }
					</div>
				</div>
			</div>
		)

		return output
	} )

	const sidecontent = range( 1, bannerlimit + 1 ).map( j => {

		const bannerTitle = attributes[ `bannertitle${ j }` ]
		const shopLink = attributes[ `shoplink${ j }` ]
		const MediaURL2 = attributes[ `mediaURL2${ j }` ]
		const bannertextcolor = attributes[ `bannertextcolor${ j }` ]
		const custombannertextcolor = attributes[ `custombannertextcolor${ j }` ]
		const bannerbgcolor = attributes[ `bannerbgcolor${ j }` ]
		const bannercustombgcolor = attributes[ `bannercustombgcolor${ j }` ]

		const bannerbgstyle = { backgroundColor: bannercustombgcolor && bannercustombgcolor }


		let defaultbannerTitle = ''
		let defaultShopLink = ''
		let defaultImg = ''

		if ( j % 3 === 1 ) {
			defaultbannerTitle = '<span class="font-weight-light">Next Gen</span><br>Video <span class="font-weight-light">with</span><br>360 Cam'
			defaultImg = `${ pluginAssetsURL }img/banner/img1.png`
			defaultShopLink = 'Shop Now'
		}
		if ( j % 3 === 2 ) {
			defaultbannerTitle = '<span class="font-weight-light">Top Rated</span><br>Gadgets<br><span class="font-weight-light">are on </span>Sale'
			defaultImg = `${ pluginAssetsURL }img/banner/img2.png`
			defaultShopLink = 'Shop Now'
		}
		if ( j % 3 === 0 ) {
			defaultbannerTitle = '<span class="font-weight-light">Catch Big</span><br>Deals <span class="font-weight-light">on</span><br>Earbuds'
			defaultImg = `${ pluginAssetsURL }img/banner/img3.png`
			defaultShopLink = 'Shop Now'
		}

		const BannerTitle =(
			<RichText
				tagName="h5"
				value={ bannerTitle || defaultbannerTitle }
				className={ `mb-2` }
				onChange={ bannerTitle => setAttributes( { [ `bannertitle${ j }` ]: bannerTitle } ) }
				placeholder={ __( 'title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)
		const ShopLink =(
			<Fragment>
				<RichText
					tagName="div"
					value={ shopLink || defaultShopLink }
					className={ `${ bannertextcolor ? bannertextcolor : custombannertextcolor ? '' : j === 1 ? 'text-info' : j === 2 ? 'text-warning' : j === 3 ? 'text-success' : ''  } font-size-sm d-inline` }
					style={ { color: custombannertextcolor } }
					onChange={ shopLink => setAttributes( { [ `shoplink${ j }` ]: shopLink } ) }
					placeholder={ __( 'ShopLink', i18n ) }
					keepPlaceholderOnFocus
				/>
				<i className={ `czi-arrow-right font-size-xs ml-1 ${ bannertextcolor ? bannertextcolor : custombannertextcolor ? '' : j === 1 ? 'text-info' : j === 2 ? 'text-warning' : j === 3 ? 'text-success' : ''  }` }></i>
			</Fragment>
		)
		const output = (
			<a className={ `media w-100 align-items-center ${ bannerbgcolor ? bannerbgcolor : bannercustombgcolor ? '' : j === 1 ? 'bg-faded-info' : j === 2 ? 'bg-faded-warning' : j === 3 ? 'bg-faded-success' : '' } rounded-lg pt-2 pl-2 mb-4 mr-4 mr-xl-0 ` } href="javascript:;" style={ bannerbgstyle } key={ j }>
				<img src={ MediaURL2 !== undefined ? MediaURL2 : defaultImg } width="125" alt="Banner" />
				<div className="media-body py-4 px-2">
					{ BannerTitle }
					{ ShopLink }
				</div>
			</a>
		)

		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-2.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots : true,
		arrows : false,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		speed: 500,		
		autoplay: autoplay,
		pauseOnHover: true,
	}, props )

	let carouselOptions = {
		slidesToShow: 1,
		dots: true,
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
	] )

	return (
		<div ref={ slickEl } id={ blockId || clientId } className={ mainClasses }>
			<section className={ `${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-secondary' } py-4 pt-md-5` } style={ bgstyle } >
				<div className="container py-xl-2">
					<div className="row align-items-center">
						<div className="col-xl-9 pt-xl-4 order-xl-2">
							<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</div>
						<div className="col-xl-3 order-xl-1 pt-4 mt-3 mt-xl-0 pt-xl-0">
							<div className="d-flex d-xl-block sidebanner">
								{ sidecontent }
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )